<template>
    <div>
        <TaxRollAdjustmentsSearchUI/>
    </div>
</template>

<script>
import TaxRollAdjustmentsSearchUI from '../../../components/tax/TaxRollAdjustments/TaxRollAdjustmentsList.vue';

export default {
  name: 'TaxRollAdjustmentsSearch',
  data: () => ({

  }),
  components: {
    TaxRollAdjustmentsSearchUI,
  },
};
</script>
